import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animal-liability-exclusion',
  templateUrl: './animal-liability-exclusion.component.html',
  styleUrls: ['./animal-liability-exclusion.component.scss']
})
export class AnimalLiabilityExclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
